'use strict';

angular.module('openDataApp')
  .directive('kvknumber', ['$q', 'ApiService', function ($q, ApiService) {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function($scope, $elm, $attrs, $ctrl) {
        $ctrl.$asyncValidators.kvknr = function(modelValue) {
          if ($ctrl.$isEmpty(modelValue)) {
            return $q.when();
          }

          var def = $q.defer();

          if (isNaN(modelValue)) {
            $scope.kvk = {};
            $scope.kvkError = "Dit is geen geldig KVK-nummer.";
            def.reject();
          } else {
            ApiService.getCompany(modelValue)
              .then(
                function success(response) {
                  if (response.data.status === 0) {
                    var company = response.data;
                    $scope.kvk = {
                      name: company.name,
                      street: company.street + ' ' + company.number + company.numberaddition,
                      postal: company.postal,
                      city: company.city
                    };
                    def.resolve();
                  } else if (response.data.status === 404) {
                    $scope.kvk = {};
                    $scope.kvkError = "Dit KVK-nummer is niet gevonden.";
                    def.reject();
                  } else {
                    $scope.kvk = {};
                    def.reject();
                  }
                },
                function error() {
                  $scope.kvk = {};
                  def.reject();
                }
              );
          }

          return def.promise;
        };
      }
    };
  }]);
